<span class="text-sm block my-4 p-3 text-blueGray-700 rounded border border-solid border-blueGray-100"
                style="max-width: 400px;">

                <section class="border-gray-100 md:col-span-5 md:pb-24 md:pl-6 md:border-l order-first md:order-none">

                    <div class="mb-5 flex justify-between">
                        <dl>
                            <dt class="-mb-1 text-sm text-gray-500">Invocaciones último mes
                            </dt>
                            <dd class="font-semibold">{{statsInvocations}}</dd>
                        </dl>
                    </div>

                    <div class="mb-5 flex justify-between">
                        <dl>
                            <dt class="-mb-1 text-sm text-gray-500">Tiempos de respuesta
                            </dt>
                            <dd class="font-semibold"> Prom. {{statsRespTime}}s</dd>
                        </dl>
                    </div>
                    <div class="border-t pt-4 border-gray-100 bg-white" style="padding-top: 10px;">
                        <div>

                            <div class="font-semibold flex items-center mb-2">
                                <div class="text-lg flex items-center"><svg xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false"
                                        role="img" class="-ml-1 mr-1 text-yellow-500" width="1em" height="1em"
                                        preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                                        <path d="M11 15H6l7-14v8h5l-7 14v-8z" fill="currentColor"></path>
                                    </svg>
                                    Pruebe el servicio
                                </div>
                            </div>
                            <div class="flex items-center text-sm text-gray-500 mb-1.5">
                                <div class="inline-flex items-center space-x-0.5">
                                    <svg class="" xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true"
                                        fill="currentColor" focusable="false" role="img" width="1em" height="1em"
                                        preserveAspectRatio="xMidYMid meet" viewBox="0 0 18 19">
                                        <path
                                            d="M12.3625 13.85H10.1875V12.7625H12.3625V10.5875H13.45V12.7625C13.4497 13.0508 13.335 13.3272 13.1312 13.5311C12.9273 13.735 12.6508 13.8497 12.3625 13.85V13.85Z">
                                        </path>
                                        <path
                                            d="M5.8375 8.41246H4.75V6.23746C4.75029 5.94913 4.86496 5.67269 5.06884 5.4688C5.27272 5.26492 5.54917 5.15025 5.8375 5.14996H8.0125V6.23746H5.8375V8.41246Z">
                                        </path>
                                        <path
                                            d="M15.625 5.14998H13.45V2.97498C13.4497 2.68665 13.335 2.4102 13.1312 2.20632C12.9273 2.00244 12.6508 1.88777 12.3625 1.88748H2.575C2.28666 1.88777 2.01022 2.00244 1.80633 2.20632C1.60245 2.4102 1.48778 2.68665 1.4875 2.97498V12.7625C1.48778 13.0508 1.60245 13.3273 1.80633 13.5311C2.01022 13.735 2.28666 13.8497 2.575 13.85H4.75V16.025C4.75028 16.3133 4.86495 16.5898 5.06883 16.7936C5.27272 16.9975 5.54916 17.1122 5.8375 17.1125H15.625C15.9133 17.1122 16.1898 16.9975 16.3937 16.7936C16.5975 16.5898 16.7122 16.3133 16.7125 16.025V6.23748C16.7122 5.94915 16.5975 5.6727 16.3937 5.46882C16.1898 5.26494 15.9133 5.15027 15.625 5.14998V5.14998ZM15.625 16.025H5.8375V13.85H8.0125V12.7625H5.8375V10.5875H4.75V12.7625H2.575V2.97498H12.3625V5.14998H10.1875V6.23748H12.3625V8.41248H13.45V6.23748H15.625V16.025Z">
                                        </path>
                                    </svg>
                                </div>
                                <div class="text-gray-500 ml-auto text-xs">Token máscara: <code>[MASK]</code></div>
                            </div>

                            <form>
                                <div class="flex h-10">
                                    <input class="form-input-alt flex-1 rounded-r-none " dir="auto" name="text"
                                        placeholder="Su oración aquí ..." type="text">
                                    <button class="btn-widget w-24 h-10 px-5 rounded-l-none border-l-0" type="submit">
                                        <svg class="text-gray-600 animate-spin" xmlns="http://www.w3.org/2000/svg"
                                            xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" fill="none"
                                            focusable="false" role="img" width="1em" height="1em"
                                            preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">
                                            <g fill="none">
                                                <path opacity=".2" fill-rule="evenodd" clip-rule="evenodd"
                                                    d="M12 19a7 7 0 1 0 0-14a7 7 0 0 0 0 14zm0 3c5.523 0 10-4.477 10-10S17.523 2 12 2S2 6.477 2 12s4.477 10 10 10z"
                                                    fill="currentColor"></path>
                                                <path d="M12 22c5.523 0 10-4.477 10-10h-3a7 7 0 0 1-7 7v3z"
                                                    fill="currentColor"></path>
                                                <path d="M2 12C2 6.477 6.477 2 12 2v3a7 7 0 0 0-7 7H2z"
                                                    fill="currentColor">
                                                </path>
                                            </g>
                                        </svg>
                                        <span class="btn-text">Procesar</span></button>
                                </div>
                            </form>

                            <div class="blankslate">
                                <div class="subtitle text-xs text-gray-500">
                                    <div class="mt-2 unknown">
                                        Ejemplo de línea (puede eliminarse)
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </span>
